import { useState, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Container, NbButton, NbCard } from "@/components/nb";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { setUserFromReset } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      const r = await api.post("/auth/reset-password", { token, new_password: pw });
      localStorage.setItem("sl_token", r.data.token);
      if (setUserFromReset) setUserFromReset(r.data.user);
      toast.success("Password updated. You're signed in.");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <Container className="max-w-lg">
        <NbCard color="tertiary" className="p-8" data-testid="reset-invalid">
          <h1 className="font-heading font-black text-3xl tracking-tighter">Invalid link</h1>
          <p className="mt-2 text-neutral-800">This reset link is missing its token. Ask for a new one.</p>
          <div className="mt-4"><Link to="/auth/forgot"><NbButton color="black">Request new link</NbButton></Link></div>
        </NbCard>
      </Container>
    );
  }

  return (
    <Container className="max-w-lg">
      <NbCard color="white" className="p-8">
        <h1 className="font-heading font-black text-4xl tracking-tighter">Set a new password.</h1>
        <p className="mt-2 text-neutral-700">Pick something you'll actually remember this time.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <input required type="password" placeholder="New password (min 6)" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw1" className="w-full px-4 py-3 nb-border rounded-lg bg-white" />
          <input required type="password" placeholder="Confirm new password" minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2" className="w-full px-4 py-3 nb-border rounded-lg bg-white" />
          <NbButton type="submit" color="black" disabled={loading} data-testid="reset-submit" className="w-full">
            {loading ? "Updating..." : "Update password"}
          </NbButton>
        </form>
      </NbCard>
    </Container>
  );
}
